import { isInside } from './calendarUtils.provider';
export var CalendarResizeHelper = (function () {
    function CalendarResizeHelper(resizeContainerElement, minWidth) {
        this.resizeContainerElement = resizeContainerElement;
        this.minWidth = minWidth;
    }
    CalendarResizeHelper.prototype.validateResize = function (_a) {
        var rectangle = _a.rectangle;
        if (this.minWidth && rectangle.width < this.minWidth) {
            return false;
        }
        return isInside(this.resizeContainerElement.getBoundingClientRect(), rectangle);
    };
    return CalendarResizeHelper;
}());
//# sourceMappingURL=calendarResizeHelper.provider.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-calendar/dist/esm/src/providers/calendarResizeHelper.provider.js
// module id = 674
// module chunks = 4